import React from 'react'
import Orders from './Orders/Orders'
import Rents from './Rents/Rents'
import Tab from '../../components/UI/OrderTabbedPanel/TabbedPanel'

        const MyOrders = (props) => {
    const tabs = [
        {
            index: 0,
            label: "سفارشات",
            value: <Orders />
        },
        {
            index: 1,
            label: "سفارشات اجاره ای",
            value: <Rents />
        }
    ]
    return (
            <Tab tabs={tabs}/>
            )
}

export default MyOrders